import { AxiosInstance } from 'axios';
import { apiRequest } from './apiRequest';
import { ApiResponse } from './types';

export interface CreateCustomerRequest {
  provider_id: string;
  customer: {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    date_of_birth: string;
  };
  password: string;
  address: {
    address_1: string;
    address_2: string;
    city: string;
    state: string;
    zip_code: string;
  };
}

export interface CreateCustomerResponse {
  customer_id: string;
}

export type CreateCustomer = (
  data: CreateCustomerRequest
) => Promise<ApiResponse<CreateCustomerResponse>>;

const createCustomer = (api: AxiosInstance): CreateCustomer => {
  return async (data: CreateCustomerRequest): Promise<ApiResponse<CreateCustomerResponse>> => {
    console.log('will create new customer with data:', data);
    return apiRequest<CreateCustomerResponse>(api, {
      method: 'POST',
      url: `/api/custom-booking/customer`,
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  };
};

export default createCustomer;